{
  "mar": {
    "title": "투약 기록",
    "loading": "투약 기록을 불러오는 중...",
    "emptyState": "이 환자에게 활성 투약 처방이 없습니다",
    "loadError": "약물 로드 실패",
    "retry": "다시 시도",
    "previousDay": "이전 날",
    "nextDay": "다음 날",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "교대",
    "dayShiftHeader": "주간 근무(07:00 - 19:00)",
    "nightShiftHeader": "야간 근무(19:00 - 07:00)",
    "newOrder": "신규 투약 처방",
    "printMar": "투약 기록 인쇄",
    "prnSection": "필요 시(PRN) 약물",
    "filter": {
      "timeWindow": "시간대",
      "category": "분류",
      "status": "상태",
      "scheduledOnly": "예정 투약만 보기"
    },
    "adminStatus": {
      "scheduled": "예정됨",
      "dueNow": "투약 시간",
      "overdue": "지연",
      "administered": "투여됨",
      "held": "보류",
      "refused": "거부",
      "missed": "미투여"
    },
    "columns": {
      "medication": "약품",
      "drug": "약품",
      "doseRoute": "용량 / 경로",
      "schedule": "스케줄",
      "scheduledTime": "예정 시간",
      "givenTime": "투약 시간",
      "givenBy": "투약자",
      "status": "상태"
    },
    "actions": {
      "administer": "투약",
      "hold": "보류",
      "refuse": "거부",
      "skip": "건너뛰기",
      "missed": "미투약으로 표시",
      "edit": "투약 기록 편집",
      "viewHistory": "이력 보기",
      "givePrn": "PRN 투약"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "고위험 의약품",
      "indication": "적응증: {{indication}}",
      "lastGiven": "직전 투약: {{time}}",
      "lastGivenBy": "직전 투약: {{time}} ({{user}})"
    },
    "orderBadge": {
      "active": "진행 중",
      "onHold": "보류 중",
      "discontinued": "중단"
    },
    "legend": "범례:",
    "summary": {
      "medsGivenToday": "오늘 투약: ",
      "ofTotal": "{{given}} / {{total}}",
      "overdueCount_one": "지연 {{count}}건",
      "overdueCount_other": "지연 {{count}}건",
      "nextDue": "다음 투약: ",
      "nextDueAt": "{{medName}} ({{time}})"
    },
    "tooltip": {
      "given": "({{time}} 투약 완료)",
      "pending": "기록 중… 서버에서 아직 확인되지 않음"
    },
    "doseModal": {
      "title": "투약",
      "doseGiven": "실투약 용량",
      "siteOfAdministration": "투약 부위",
      "comments": "비고",
      "vitalsCheck": "투약 전 활력 징후 확인",
      "doubleCheck": "이중 확인",
      "verifier": "확인자",
      "confirm": "투약 확정"
    },
    "administerDialog": {
      "doseLabel": "용량",
      "routeLabel": "투여 경로",
      "siteLabel": "투약 부위 (해당 시)",
      "site": {
        "notApplicable": "해당 없음",
        "leftArm": "왼팔",
        "rightArm": "오른팔",
        "leftDeltoid": "왼쪽 삼각근",
        "rightDeltoid": "오른쪽 삼각근",
        "leftGluteal": "왼쪽 둔부",
        "rightGluteal": "오른쪽 둔부",
        "leftThigh": "왼쪽 허벅지",
        "rightThigh": "오른쪽 허벅지",
        "abdomen": "복부"
      },
      "timeAdministered": "투약 시간",
      "administeredDateAria": "투약 날짜",
      "administeredTimeAria": "투약 시각",
      "notesLabel": "비고",
      "notesPlaceholder": "선택 사항 비고..."
    },
    "prnWarning": {
      "title": "PRN 간격 경고",
      "lastDoseHoursAgo": "마지막 투약 후 {{hours}}시간 경과.",
      "minimumInterval": "최소 간격은 {{hours}}시간입니다.",
      "lastAdministered": "마지막 투약: {{time}}",
      "justificationLabel": "조기 투약 사유",
      "justificationRequired": "*",
      "justificationPlaceholder": "최소 간격 전 투약의 임상적 사유를 입력하십시오...",
      "cancel": "취소",
      "overrideContinue": "재정의 후 계속"
    },
    "toast": {
      "administered": "투약이 기록되었습니다",
      "administerError": "투약 기록 실패",
      "administerNotImplemented": "MAR 투약 기록 기능을 아직 사용할 수 없습니다",
      "held": "투약을 보류했습니다",
      "refused": "환자 거부가 기록되었습니다",
      "skipped": "투약을 건너뛰었습니다",
      "orderNotActive": "이 처방은 더 이상 유효하지 않아(중단·취소·완료) 투약을 기록할 수 없습니다."
    },
    "holdRefuseDialog": {
      "holdTitle": "투약 보류",
      "refuseTitle": "투약 거부",
      "skipTitle": "투약 건너뛰기",
      "scheduledLabel": "예정: {{time}}",
      "holdReasonLabel": "보류 사유",
      "refusalNotesLabel": "거부 기록",
      "skipReasonLabel": "건너뛰기 사유",
      "holdReasonPlaceholder": "보류 사유 입력...",
      "refusalPlaceholder": "환자 거부 사항 기록...",
      "skipPlaceholder": "건너뛰기 사유 입력...",
      "cancel": "취소",
      "confirm": "확인"
    },
    "contextMenu": {
      "hold": "보류",
      "refuse": "거부",
      "skip": "건너뛰기"
    },
    "holdReason": {
      "label": "보류 사유",
      "options": {
        "patientNpo": "환자 NPO(금식)",
        "vitalsOutOfRange": "활력 징후 범위 초과",
        "patientRefused": "환자 거부",
        "providerOrder": "의사 보류 지시",
        "other": "기타"
      }
    },
    "give": {
      "title": "투약 · {{medication}} {{dose}}",
      "scheduledLabel": "예정 {{time}}",
      "patientLabel": "환자",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "환자 ID: {{id}}",
      "medicationLabel": "약품",
      "scanPatientPlaceholder": "손목밴드 스캔",
      "scanPatientAria": "환자 손목밴드 스캔",
      "scanMedicationPlaceholder": "약품 포장 바코드 스캔",
      "scanMedicationAria": "약품 포장 스캔",
      "patientMismatch": "이 손목밴드는 해당 환자의 것이 아닙니다. 투약하지 마십시오.",
      "medicationMismatch": "이 포장은 처방된 약품이 아닙니다. 투약하지 마십시오.",
      "notScannable": "스캔 대조 불가 — 이 처방에 등록된 바코드가 없습니다",
      "overrideReason": "스캔 없이 투약하는 사유",
      "overrideReasonPlaceholder": "예: 손목밴드 손상, 바코드가 없는 조제 용량",
      "pharmacyOverride": "약제부가 이 고위험 의약품을 검수하지 않았습니다",
      "__review_pharmacyOverride": "Pharmacy-verification verb: this file uses 검수 throughout (incl. pharmacist.*); 처방 감사 may be the standard term — needs a file-wide translator decision, not a partial change",
      "pharmacyOverridePlaceholder": "이 투약이 약제부 검토를 기다릴 수 없는 이유는?",
      "timeLabel": "시간",
      "detailsEdit": "편집",
      "detailsDone": "완료",
      "confirmLabel": "처방 및 준비한 약품과 일치함을 확인합니다",
      "cancel": "취소",
      "submit": "투약",
      "witness": {
        "banner": "고위험 의약품 — 제2간호사 입회 확인 필요",
        "usernameLabel": "제2간호사 사용자명",
        "passwordLabel": "비밀번호",
        "verify": "확인",
        "verifying": "확인 중…",
        "verified": "제2간호사가 입회 확인함",
        "rejected": "인증 정보를 확인할 수 없습니다.",
        "overrideLabel": "입회 확인 불가? 제2간호사 확인 없이 투약하는 사유",
        "overridePlaceholder": "이 투약이 독립적인 이중 확인을 기다릴 수 없는 이유는?"
      },
      "refusal": {
        "wrongPatient": "환자 불일치 — 스캔한 손목밴드가 이 처방과 일치하지 않습니다. 투약하지 마십시오.",
        "wrongMedication": "약품 불일치 — 스캔한 포장이 처방된 약품과 일치하지 않습니다. 투약하지 마십시오.",
        "scanRequired": "손목밴드와 약품을 스캔하거나 스캔하지 않는 사유를 입력하십시오.",
        "pharmacyVerificationRequired": "약제부가 이 처방을 검수하지 않았습니다. 검수를 기다리거나 기다릴 수 없는 사유를 기록하십시오.",
        "doubleCheckRequired": "이 처방에 대한 제2간호사의 이중 확인이 없습니다. 입회 확인을 받거나 기다릴 수 없는 사유를 기록하십시오.",
        "doubleCheckSelf": "본인의 투약을 본인이 입회 확인할 수 없습니다. 제2간호사가 확인해야 합니다."
      },
      "dispense": {
        "handedOver": "{{quantity}} {{time}}에 전달됨",
        "label": "약국 조제",
        "none": "이 처방에 대한 조제 기록이 없습니다",
        "pending": "조제 기록됨, 아직 전달되지 않음",
        "prepared": "{{quantity}} {{time}}에 조제됨",
        "unavailable": "조제 여부를 확인할 수 없습니다 — 기록에 접근하지 못했습니다"
      }
    }
  },
  "status": {
    "active": "진행 중",
    "held": "보류",
    "discontinued": "중단",
    "completed": "완료",
    "refused": "거부",
    "missed": "미투여",
    "given": "투여됨"
  },
  "route": {
    "po": "경구",
    "iv": "정맥주사",
    "im": "근육주사",
    "sc": "피하주사",
    "in": "비강",
    "pr": "직장",
    "sl": "설하",
    "top": "외용",
    "neb": "분무 흡입",
    "pv": "질",
    "ng": "비위관",
    "ophthalmic": "점안",
    "transdermal": "경피"
  },
  "frequency": {
    "bid": "하루 2회",
    "tid": "하루 3회",
    "qid": "하루 4회",
    "qd": "하루 1회",
    "qhs": "취침 시",
    "prn": "필요 시(PRN)",
    "stat": "즉시(STAT)",
    "continuous": "지속 투약"
  },
  "formulary": {
    "title": "약품 처방집",
    "searchPlaceholder": "약품명, 일반명 또는 코드로 검색...",
    "clearSearch": "검색 지우기",
    "category": {
      "all": "전체",
      "analgesic": "진통제",
      "antibiotic": "항생제",
      "antifungal": "항진균제",
      "antiviral": "항바이러스제",
      "cardiac": "심혈관계",
      "endocrine": "내분비계",
      "gi": "소화기계",
      "neurological": "신경계",
      "psychiatric": "정신과",
      "respiratory": "호흡기계",
      "other": "기타"
    },
    "columns": {
      "medication": "약품",
      "genericName": "일반명",
      "form": "제형",
      "strength": "규격",
      "route": "투여 경로",
      "status": "상태",
      "schedule": "규제 등급"
    },
    "highAlertBadge": "고위험 의약품",
    "highAlertTag": "고위험",
    "status": {
      "preferred": "권장",
      "restricted": "제한",
      "nonFormulary": "처방집 외"
    },
    "loading": "처방집 불러오는 중...",
    "loadError": "처방집을 불러오지 못했습니다",
    "empty": "약품을 찾을 수 없습니다.",
    "pagination": {
      "showing": "{{from}}-{{to}} / 총 {{total}}건",
      "page": "{{page}} / {{totalPages}} 페이지",
      "previous": "이전 페이지",
      "next": "다음 페이지"
    },
    "details": {
      "close": "상세 닫기",
      "genericName": "일반명",
      "category": "분류",
      "formStrength": "제형 / 규격",
      "route": "투여 경로",
      "formularyStatus": "처방집 상태",
      "deaSchedule": "DEA 규제 등급",
      "indications": "적응증",
      "contraindications": "금기",
      "interactions": "약물 상호작용",
      "sideEffects": "이상반응",
      "dosageGuidelines": "용법·용량",
      "specialPopulations": "특수 집단",
      "storage": "보관"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "약사 검토 대기열",
    "subtitle": "대기 중인 처방을 검토하고 확인합니다",
    "pendingCount": "대기 {{count}}건",
    "refresh": "새로고침",
    "searchPlaceholder": "약품, 환자명 또는 MRN으로 검색...",
    "priority": {
      "all": "전체 우선순위",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "일반",
      "scheduled": "예정"
    },
    "loadError": "처방 대기열을 불러오지 못했습니다",
    "retry": "다시 시도",
    "empty": {
      "title": "모두 처리 완료",
      "description": "검토할 처방이 없습니다."
    },
    "columns": {
      "patient": "환자",
      "medication": "약품",
      "doseRouteFreq": "용량 / 경로 / 빈도",
      "priority": "우선순위",
      "orderingProvider": "처방의",
      "ordered": "처방 시각",
      "actions": "작업"
    },
    "row": {
      "unknown": "알 수 없음",
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "controlled": "규제약 {{schedule}}",
      "providerFallback": "의사 #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "검토 확인",
      "verifyTooltip": "이 처방을 확인합니다",
      "reject": "반려",
      "rejectTooltip": "반려하고 중단",
      "confirmReject": "확인",
      "cancelReject": "취소",
      "rejectReasonPlaceholder": "반려 사유..."
    },
    "toast": {
      "verifySuccess": "처방 #{{id}} 확인 완료",
      "verifyError": "처방 확인에 실패했습니다",
      "rejectSuccess": "처방 #{{id}} 반려 및 중단",
      "rejectError": "처방 반려에 실패했습니다",
      "rejectReasonRequired": "반려 사유를 입력해주세요",
      "notIndependent": "처방자는 자신의 처방을 검수할 수 없습니다.",
      "overrideSuccess": "처방 {{id}}이(가) 약사 검증 없이 활성화되었습니다",
      "overrideError": "오버라이드를 기록할 수 없습니다",
      "overrideReasonRequired": "오버라이드에는 사유 코드와 설명이 모두 필요합니다"
    },
    "verifyDialog": {
      "title": "처방 검수",
      "instruction": "완료한 항목을 모두 확인하세요. 네 항목 모두 필수입니다 — 부분 검토는 검수가 아닙니다.",
      "checks": {
        "allergy": "환자의 알레르기와 대조해 검토했습니다",
        "interaction": "약물 상호작용을 검토했습니다",
        "duplicateTherapy": "중복 처방을 검토했습니다",
        "doseRange": "이 환자의 용량을 검토했습니다"
      },
      "cancel": "취소",
      "confirm": "처방 검수"
    },
    "override": {
      "action": "오버라이드",
      "confirm": "오버라이드 기록",
      "cancel": "취소",
      "tooltip": "약사 검증 없이 진행합니다. 사유를 기록하지만 고위험 약물의 약제부 확인을 대체하지 않습니다.",
      "codeLabel": "오버라이드 사유 코드",
      "codePlaceholder": "사유 선택…",
      "justificationLabel": "오버라이드 사유",
      "justificationPlaceholder": "약제부 검토 없이 진행하는 이유는?",
      "code": {
        "pharmacyClosed": "약제부 마감",
        "urgentClinicalNeed": "긴급한 임상적 필요",
        "pharmacyUnreachable": "약제부 연락 불가"
      }
    },
    "clarify": {
      "action": "의문 조회",
      "tooltip": "약제부가 이 처방을 다르게 입력했습니다. 해결해야 투약할 수 있습니다.",
      "heading": "약제부 입력이 처방과 다릅니다",
      "holding": "(처방 보류)",
      "upheld": "원처방 유지",
      "upheldTooltip": "원처방이 옳으므로 기재대로 조제합니다.",
      "amended": "수정했습니다",
      "amendedTooltip": "처방을 변경했음을 기록합니다.",
      "adopt": "약제부 안 채택",
      "adoptTooltip": "협업 실무 협약 또는 약사위원회 프로토콜에 따라 입력 내용을 수용합니다.",
      "close": "닫기",
      "toast": {
        "resolved": "의문 조회가 해결되었습니다. 처방은 검증 대기로 돌아갑니다",
        "error": "의문 조회를 해결할 수 없습니다"
      }
    }
  },
  "reconciliation": {
    "title": "약물 조정",
    "subtitle": "{{patient}} | {{mrn}} | 진료 #{{encounter}}",
    "complete": "조정 완료",
    "loading": "약물 정보를 불러오는 중...",
    "column": {
      "home": "재원 전 복용약",
      "inpatient": "입원 처방",
      "discharge": "퇴원 처방"
    },
    "emptyHome": "재원 전 복용약을 찾을 수 없습니다.",
    "emptyInpatient": "입원 처방을 찾을 수 없습니다.",
    "emptyDischarge": "퇴원 처방이 아직 없습니다. 다른 열에서 계속 또는 변경을 선택하세요.",
    "changedFromHome": "재원 전 복용약과 비교해 변경됨",
    "action": {
      "continue": "지속",
      "modify": "변경",
      "discontinue": "중단",
      "discontinueShort": "D/C",
      "newOrder": "신규"
    },
    "addToDischarge": "퇴원 처방에 추가",
    "remove": "제거",
    "modifyForm": {
      "title": "약물 변경",
      "dose": "용량",
      "route": "투여 경로",
      "frequency": "투여 빈도",
      "dosePlaceholder": "예: 500mg",
      "routePlaceholder": "예: PO",
      "frequencyPlaceholder": "예: BID",
      "cancel": "취소",
      "save": "저장"
    },
    "back": "뒤로",
    "toast": {
      "completed": "약물 조정이 완료되었습니다",
      "completeError": "조정 완료에 실패했습니다",
      "atLeastOne": "완료하기 전에 최소 한 건의 약물을 조정해 주세요"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "용량 계산기",
      "weightLabel": "환자 체중 (kg) *",
      "heightLabel": "신장 (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "예: 70",
      "heightPlaceholder": "예: 170",
      "gfrPlaceholder": "선택 사항",
      "bsaLabel": "계산된 체표면적 (Mosteller):",
      "calculate": "용량 계산",
      "error": "용량을 계산하지 못했습니다. 이 약물에 대한 용량 데이터가 백엔드에 없을 수 있습니다.",
      "renalAdjustment": "신장 조정:",
      "originalDose": "원래 용량:",
      "min": "최소:",
      "max": "최대:",
      "recommended": "권장: {{dose}} {{unit}}",
      "apply": "용량 적용",
      "method": {
        "weightBased": "체중 기준",
        "bsaBased": "체표면적 기준",
        "flat": "고정 용량",
        "renalAdjusted": "신장 조정"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "약물 처방",
    "submit": "처방",
    "navButton": "처방",
    "noActiveEncounter": "처방은 활성 진료에 연결되어야 합니다. 처방하기 전에 이 환자의 진료를 시작하거나 입원시키십시오.",
    "fields": {
      "medication": "약물",
      "dose": "용량",
      "doseUnit": "단위",
      "route": "투여 경로",
      "frequency": "빈도",
      "frequencyDescription": "빈도 설명",
      "duration": "투여 기간",
      "durationUnit": "기간 단위",
      "totalDoses": "총 투여 횟수",
      "isPrn": "필요시(PRN)",
      "prnIndication": "필요시 적응증",
      "administrationInstructions": "투여 지침",
      "patientInstructions": "환자 안내",
      "quantityDispensed": "조제 수량",
      "refillsAuthorized": "재조제 허용 횟수",
      "allowSubstitution": "제네릭 대체 허용",
      "pharmacyNotes": "약국 메모",
      "indication": "적응증",
      "clinicalIndication": "임상 적응증",
      "priority": "우선순위"
    },
    "sections": {
      "drug": "약물",
      "dosing": "용량",
      "durationPrn": "투여 기간 · 필요시(PRN)",
      "instructions": "투여 지침",
      "dispensing": "조제",
      "clinical": "임상"
    },
    "doseUnitPlaceholder": "예: mg",
    "drugSearch": {
      "placeholder": "처방집 검색…",
      "noResults": "일치하는 처방집 약물이 없습니다",
      "clear": "선택 해제",
      "catalogRequired": "처방할 약물을 처방집에서 선택하세요",
      "catalogOnly": "모든 안전 점검이 수행되도록 처방집 약물만 처방할 수 있습니다.",
      "controlledBadge": "규제 약물 — 스케줄 {{schedule}}",
      "controlledTag": "규제",
      "highAlertBadge": "고위험 의약품",
      "highAlertTag": "고위험",
      "contraindications": "금기: {{text}}"
    },
    "route": {
      "oral": "경구(PO)",
      "iv": "정맥주사(IV)",
      "subcutaneous": "피하주사(SC)",
      "intramuscular": "근육주사(IM)",
      "topical": "국소",
      "inhalation": "흡입",
      "rectal": "직장(PR)",
      "ophthalmic": "점안",
      "transdermal": "경피"
    },
    "frequency": {
      "QD": "1일 1회(QD)",
      "BID": "1일 2회(BID)",
      "TID": "1일 3회(TID)",
      "QID": "1일 4회(QID)",
      "Q4H": "4시간마다(Q4H)",
      "Q6H": "6시간마다(Q6H)",
      "Q8H": "8시간마다(Q8H)",
      "Q12H": "12시간마다(Q12H)",
      "QHS": "취침 시(QHS)",
      "PRN": "필요시(PRN)",
      "STAT": "즉시(STAT)"
    },
    "durationUnit": {
      "days": "일",
      "weeks": "주",
      "months": "개월",
      "doses": "회"
    },
    "priority": {
      "routine": "일반",
      "asap": "가능한 빨리",
      "stat": "응급"
    },
    "validation": {
      "prnIndicationRequired": "필요시 처방에는 필요시 적응증이 필요합니다"
    },
    "contextBar": {
      "ariaLabel": "처방 참고 정보",
      "allergies": {
        "label": "알레르기",
        "none": "알려진 알레르기 없음",
        "severe": "중증"
      },
      "weight": {
        "label": "체중",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "기록 없음"
      },
      "renal": {
        "label": "신장 기능",
        "value": "eGFR {{egfr}} {{unit}} ({{source}})",
        "unknown": "신장 기능 미상",
        "source": {
          "reported": "보고값",
          "computed": "계산값",
          "unknown": "미상"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "약물이 처방되었습니다",
      "error": "처방을 등록할 수 없습니다. 다시 시도해 주세요.",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "안전 권고와 함께 처방됨",
      "continue": "계속"
    },
    "safetyReview": {
      "title": "안전성 검토 필요",
      "proceed": "재정의 후 처방",
      "cancel": "취소",
      "reasonPrompt": "재정의 사유 선택…",
      "freeTextLabel": "추가 세부 정보",
      "freeTextPlaceholder": "임상적 배경 추가 (선택 사항)",
      "hardBlockNote": "이 차단은 재정의할 수 없습니다.",
      "cannotOverride": "이 처방은 진행할 수 없습니다 — 하나 이상의 차단을 재정의할 수 없습니다.",
      "blockKind": {
        "cds_contraindication": "금기",
        "cds_unavailable": "안전성 스크리닝 불가",
        "renal_contraindication": "신장 금기",
        "dose_range": "권장 범위를 벗어난 용량",
        "pregnancy_contraindication": "임신 위험",
        "unknown": "추가 안전성 차단"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "병력을 수동으로 검토함",
        "NO_KNOWN_RISK_THIS_PATIENT": "이 환자에게 알려진 위험 없음",
        "URGENT_CLINICAL_NEED": "긴급한 임상적 필요",
        "OTHER": "기타 (명시)",
        "BENEFIT_OUTWEIGHS_RISK": "이익이 위험보다 큼",
        "DOSE_REDUCED_PER_PROTOCOL": "프로토콜에 따라 용량 감소",
        "EGFR_NOT_REPRESENTATIVE": "eGFR가 대표적이지 않음",
        "SPECIALIST_ADVICE": "전문의 조언",
        "PATIENT_TOLERANT": "환자가 이 용량에 내약함",
        "SPECIALIST_PROTOCOL": "전문의 프로토콜에 따름",
        "TITRATING_TO_EFFECT": "효과에 맞춰 적정",
        "RANGE_NOT_APPLICABLE": "범위 적용 안 됨",
        "STATUS_CONFIRMED_NEGATIVE": "임신하지 않음을 확인함",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "이익이 태아 위험보다 큼",
        "CONTRACEPTION_CONFIRMED": "효과적인 피임 확인됨",
        "PREGNANCY_BEING_TERMINATED": "임신 중절 진행 중"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
